"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tabs = void 0;

var _stylitas = require("@creditas/stylitas");

const tabs = () => (0, _stylitas.css)`
  display: flex;
`;

exports.tabs = tabs;